/* eslint-disable */
import { SvgDonate } from './SvgDonate'
import { SvgKargoeCare } from './SvgKargoeCare'
import { SvgEditProfile } from './SvgEditProfile'
import { SvgTouchId } from './SvgTouchId'
import { SvgDelivery } from './SvgDelivery'
import { SvgPush } from './SvgPush'
import { SvgBackButton } from './SvgBackButton'
import { SvgHome } from './SvgHome'
import { SvgCamera } from './SvgCamera'
import { SvgHappening } from './SvgHappening'
import { SvgKargoelytics } from './SvgKargoelytics'
import { SvgKargoelyticsRed } from './SvgKargoelyticsRed'
import { SvgSetting } from './SvgSetting'
import { SvgMessages } from './SvgMessages'
import { SvgMessagesRed } from './SvgMessagesRed'
import { SvgPeopleActive } from './SvgPeopleActive'
import { SvgPeople } from './SvgPeople'
import { SvgMyShopActive } from './SvgMyShopActive'
import { SvgMyShop } from './SvgMyShop'
import { SvgDivider } from './SvgDivider'
import { SvgDonationEditPostActive } from './SvgDonationEditPostActive'
import { SvgLocationEditPostActive } from './SvgLocationEditPostActive'
import { SvgShipping } from './SvgShipping'
import { SvgCoffee } from './SvgCoffee'


import { SvgTilt } from './SvgLogoWall'
import { SvgLogoWall } from './SvgLogoWall'
import { SvgProfileMenu } from './SvgProfileMenu'
import { SvgDocument } from './SvgDocument'
import { SvgExplora } from './SvgExplora'
import { SvgVideo } from './SvgVideo'
import { SvgPostView } from './SvgPostView'
import { SvgPostHeartOff } from './SvgPostHeartOff'
import { SvgPostCommentOff } from './SvgPostCommentOff'
import { SvgPostKargotagOn } from './SvgPostKargotagOn'
import { SvgPostHastag } from './SvgPostHastag'
import { SvgPostMore } from './SvgPostMore'
import { SvgX } from './SvgX'
import { SvgPlusProfile } from './SvgPlusProfile'
import { SvgMinusProfile } from './SvgMinusProfile'
import { SvgBlockUser } from './SvgBlockUser'
import { SvgSearch } from './SvgSearch'
import { SvgEndorse } from './SvgEndorse'
import { SvgEndorseActive } from './SvgEndorseActive'
import { SvgPinkTouchId } from './SvgPinkTouchId'
import { SvgClose } from './SvgClose'
import { SvgCloseBlack } from './SvgCloseBlack'
import { SvgBlueBarCoder } from './SvgBlueBarCoder'
import { SvgDonationEditPost } from './SvgDonationEditPost'
import { SvgLocationEditPost } from './SvgLocationEditPost'
import { SvgWhiteBarcoder } from './SvgWhiteBarcoder'
import { SvgCloseRed } from './SvgCloseRed'
import { SvgNoComments } from './SvgNoComments'
import { SvgAirPlane } from './SvgAirPlane'
import { SvgLocationPin } from './SvgLocationPin'
import { SvgLocationX } from './SvgLocationX'
import { SvgLocationCalloutX } from './SvgLocationCalloutX'
import { SvgLocationSearch } from './SvgLocationSearch'
import { SvgMessageBubble } from './SvgMessageBubble'
import { SvgMessageCamera } from './SvgMessageCamera'
import { SvgWhiteAirPlane } from './SvgWhiteAirPlane'
import { SvgArrowDown } from './SvgArrowDown'
export {
    SvgEndorse,
    SvgEndorseActive,
    SvgDonate,
    SvgKargoeCare,
    SvgEditProfile,
    SvgTouchId,
    SvgDelivery,
    SvgPush,
    SvgHappening,
    SvgKargoelytics,
    SvgKargoelyticsRed,
    SvgCamera, SvgBackButton,
    SvgHome,
    SvgSetting,
    SvgMessages,
    SvgMessagesRed,
    SvgLogoWall,
    SvgTilt, SvgProfileMenu,
    SvgDocument,
    SvgExplora,
    SvgVideo, SvgPostView,
    SvgPostHeartOff,
    SvgPostCommentOff,
    SvgPostKargotagOn,
    SvgPostHastag,
    SvgPostMore,
    SvgX,
    SvgClose,
    SvgCloseBlack,
    SvgPlusProfile,
    SvgMinusProfile,
    SvgBlockUser,
    SvgSearch,
    SvgPinkTouchId,
    SvgBlueBarCoder,
    SvgPeople,
    SvgMyShop,
    SvgDivider,
    SvgDonationEditPost,
    SvgLocationEditPost,
    SvgPeopleActive,
    SvgMyShopActive,
    SvgDonationEditPostActive,
    SvgLocationEditPostActive,
    SvgWhiteBarcoder,
    SvgCloseRed,
    SvgNoComments,
    SvgAirPlane,
    SvgLocationPin,
    SvgLocationX,
    SvgLocationCalloutX,
    SvgShipping,
    SvgCoffee,
    SvgLocationSearch,
    SvgMessageBubble,
    SvgMessageCamera,
    SvgWhiteAirPlane,
    SvgArrowDown
}
